import { render, staticRenderFns } from "./EditeContractorTelegramModal.vue?vue&type=template&id=48e93cb7"
import script from "./EditeContractorTelegramModal.vue?vue&type=script&lang=js"
export * from "./EditeContractorTelegramModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports